import axios from 'src/utils/axios';


export const sendSubscriptionToPushServer = (userSubscription) => axios.post('/PushNotification/Subscribe', userSubscription);
export const getNotifications = (employeeId) => axios.get(`/getInternalNotifications/${employeeId}`);
export const readNotifications = (employeeId,MaxId) => axios.get(`/readInternalNotifications/${employeeId}/${MaxId}`);
export const notifyNotificationViewed = (id) => axios.delete(`/PushNotification/${id}`);
